import { lazy, Suspense } from 'react'
import { UserRole } from '../enums'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import LoadingState from '../components/LoadingState'
const GeneratorsPage = lazy(() => import('../pages/Generators'))
const GeneratorPage = lazy(() => import('../pages/Generator'))
const EditGeneratorPage = lazy(() => import('../pages/EditGenerator'))

export default [
  {
    path: '/generators',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <GeneratorsPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/generators/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.MANUFACTURER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.INSTALLER
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <GeneratorPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/generators/:id/edit',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.MANUFACTURER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.INSTALLER
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <EditGeneratorPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
